/**
 * Saved estimates, stored in this browser (localStorage)
 */

import { normalizeEstimate } from './estimateEngine';

const STORAGE_KEY = 'rumahkira_projects';
const MAX_PROJECTS = 30;

const readRaw = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeRaw = (projects) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(projects.slice(0, MAX_PROJECTS)));
  } catch {
    // Storage full or blocked; nothing else we can do here
  }
};

/**
 * All saved projects in the current format, newest first
 */
export const getProjects = () =>
  readRaw()
    .map((p) => {
      const normalized = normalizeEstimate(p);
      return normalized ? { ...normalized, id: String(p.id), savedAt: p.savedAt || normalized.generatedAt } : null;
    })
    .filter(Boolean)
    .sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt));

export const getProject = (id) => getProjects().find((p) => p.id === String(id)) || null;

/**
 * Save (or update, when it already has an id) an estimate
 * @returns the saved project including its id
 */
export const saveProject = (estimate) => {
  const id = estimate.id ? String(estimate.id) : `p_${Date.now()}`;
  const project = { ...estimate, id, savedAt: new Date().toISOString() };
  const others = readRaw().filter((p) => String(p.id) !== id);
  writeRaw([project, ...others]);
  return project;
};

export const deleteProject = (id) => {
  writeRaw(readRaw().filter((p) => String(p.id) !== String(id)));
};
